<script>
    import { onMount } from 'svelte';
    import { authState } from 'rxfire/auth';
    import { docData } from 'rxfire/firestore';
    import { db, timestamp, auth, functions} from '../firebase';
    import { user, profileData } from '../store';

    onMount(() => {
        // Subscribe to auth state
        const unsubscribe = authState(auth).subscribe(u => {
            setTimeout(() => {
                user.set(u)
                checkIfNewUser(u);
                getProfileData(u);
                // show loading screen for two seconds. without that, you'll never see the egg
            },2000)
        });
    });
    
    // Check if user already exist
    function checkIfNewUser(user) {       
        //after we have the credential - lets check if the user exists in firestore
        if(user) {
            const docRef = db.collection('users').doc(user.uid);
            docRef.get().then(doc => {
                if (doc.exists) {
                    // console.log('user exists, do nothing');
                    return user;
                } else {
                    // console.log('user doesn\'t exist - create a new user in firestore');
                    addNewUserToFirestore(user);
                }
            }).catch(function(error) {
                console.error('Check if user exists failed ' + error);
            });
        }
    }
    
    // Create new user
    async function addNewUserToFirestore(user) {
        const collection = db.collection('users');
        const details = {
            uid: user.uid,
            name: user.displayName,
            email: user.email,
            picture: user.photoURL,
            joined: timestamp,
            ideas: [],
            chats: [],
            saved: []
        };
        await collection.doc(auth.currentUser.uid).set(details);
        sendWelcomeEmail(user)
        return {user, details};
    }
    
    // Get profile user data
    function getProfileData(user) {
        if(user) {
            const profile = docData(db.collection('users').doc(user.uid));
            profile.subscribe((data) => {
                profileData.set(data);
            });
        }
    }

    function sendWelcomeEmail(user) {
        // send welcome email
        const sendEmail = functions.httpsCallable('sendEmail');
        sendEmail({
            type: 'welcome',
            personalizations: [
                {
                    to: user.email,
                    dynamic_template_data: {
                        receiver_name: user.displayName
                    }
                }
            ]
        })
        .then(result => {
            messageToNotify = ""; // Reset message text to notify chat members
            // Read result of the Cloud Function.
            console.log(result.data);
        }).catch(error => {
            console.log(error);
        });
    }


</script>